import type { QuoteState, QuoteType } from 'state/quotes/infos/infos.model';
import type { WorkFlowStatus } from 'state/selectors';
export function isQuoteTypeTradable(quoteType?: QuoteType) {
  return (
    quoteType === 'Tradable' ||
    quoteType === 'ExecOnly' ||
    quoteType === 'AdvancedExecOnly' ||
    quoteType === 'AdvancedTradable'
  );
}

export function isQuoteTypeIndicative(quoteType: QuoteType) {
  return !isQuoteTypeTradable(quoteType);
}

export function isQuoteTypeWithRegulation(quoteType: QuoteType) {
  return isQuoteTypeTradable(quoteType) || quoteType === 'Executable' || quoteType === 'AdvancedExecutable';
}

export function isQuoteTypeWithExecOnly(quoteType: QuoteType) {
  return quoteType === 'ExecOnly' || quoteType === 'AdvancedExecOnly';
}

export function isQuoteTypeWithoutKid(quoteType: QuoteType) {
  return (
    quoteType === 'Indicative' ||
    quoteType === 'AdvancedIndicative' ||
    quoteType === 'ExecOnly' ||
    quoteType === 'AdvancedExecOnly'
  );
}

export function isPastQuote(quoteState: QuoteState | null | undefined) {
  return quoteState === 'Inconsistent' || quoteState === 'Previous';
}

export function isLiveQuote(quoteState: QuoteState | null | undefined) {
  return quoteState === 'Live';
}

export type ShareButtonColor =
  | 'ready'
  | 'tradable'
  | 'indicative'
  | 'previous'
  | 'nontradable'
  | 'pending'
  | 'secondaryquotedclientsell'
  | 'secondaryquotedclientbuy'
  | 'secondaryquoting';

export function getShareButtonColor(
  status: WorkFlowStatus,
  quoteType: QuoteType | undefined,
): ShareButtonColor | undefined {
  switch (status) {
    case 'QUOTED_PREVIOUSLY':
      return 'previous';
    case 'TRADE_AUTH_REJECTED':
      return 'nontradable';
    case 'TRADING':
      return 'pending';
    case 'QUOTED_TRADABLE':
    case 'QUOTED':
    case 'QUOTING':
    case 'TRADED':
      if (quoteType !== undefined && isQuoteTypeTradable(quoteType!)) {
        return 'tradable';
      }
      if (quoteType !== undefined && isQuoteTypeIndicative(quoteType!)) {
        return 'indicative';
      }
      return undefined;
    default:
      return 'ready';
  }
}
